var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Data are public after a proprietary period (usually 1 year) during which the files can be downloaded only by the Principal Investigator (PI) of the related program or collaborators authorized by the PI.")])}
var staticRenderFns = []

export { render, staticRenderFns }